class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
// Desktop-Dropdowns beim Hovern öffnen
(() => {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  function initHoverMenus() {
    document
      .querySelectorAll('.header__inline-menu details')
      .forEach((details) => {
        if (details.dataset.hoverReady) return;
        details.dataset.hoverReady = 'true';

        const summary = details.querySelector(':scope > summary');
        if (!summary) return;

        let closeTimer;

        function closeMenu() {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');

          details.querySelectorAll('details[open]').forEach((child) => {
            child.open = false;
            child
              .querySelector(':scope > summary')
              ?.setAttribute('aria-expanded', 'false');
          });
        }

        details.addEventListener('pointerenter', (event) => {
          if (!desktopHover.matches || event.pointerType !== 'mouse') return;

          clearTimeout(closeTimer);
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('pointerleave', (event) => {
          if (!desktopHover.matches || event.pointerType !== 'mouse') return;

          closeTimer = setTimeout(() => {
            // Bei Tastaturbedienung das fokussierte Menü offen halten.
            if (!details.contains(document.activeElement)) {
              closeMenu();
            }
          }, 200);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }

  // Auch nach einem Neuladen des Headers im Theme-Editor aktivieren.
  document.addEventListener('shopify:section:load', initHoverMenus);
})();
